"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _item = _interopRequireDefault(require("./item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ContentType = /*#__PURE__*/function () {
  /**
   */
  function ContentType() {
    _classCallCheck(this, ContentType);

    /**
     * @type {string}
     */
    this.id = '';
    /**
     * @type {string}
     */

    this.name = '';
    /**
     *
     * @type {Array.<Item>}
     */

    this.items = [];
    /**
     *
     * @type {Array.<Item>}
     */

    this.filteredItems = [];
  }
  /**
   * Parses loaded JSON to an instance of ContentType
   * @param {Object} dataSet
   */


  _createClass(ContentType, null, [{
    key: "fromEndpoint",
    value: function fromEndpoint(dataSet) {
      return dataSet.map(function (data) {
        var contentType = new ContentType();
        contentType.id = data.id;
        contentType.name = data.name;
        data.files.forEach(function (file) {
          contentType.items.push(_item["default"].fromEndpoint(file));
        });
        return contentType;
      });
    }
  }]);

  return ContentType;
}();

var _default = ContentType;
exports["default"] = _default;